import 'SF/Router.js';
import 'SF/RouterContext.js';
import 'SF/Window.js';
import 'SF/PlaceholderPanel.js';
import 'SF/GridPanel.js';
import 'SF/AbstractPopupPanel.js';
import 'SF/Popup.js';
import 'SF/StudentListFilterPopupBase.js';
import 'SF/AbstractStudentListPanel.js';
import 'SF/AbstractCourseCentricStudentListPanel.js';
import 'SF/TaskManager.js';
import 'SF/PanelEnhanced.js';
import 'SF/GridPanelEnhanced.js';
import 'SF/TabPanel.js';
import 'SF/Chart.js';
import 'SF/admin/prospects/MergeConfirmationPanel.js';
import 'SF/admin/prospects/MergeWindow.js';
import 'SF/admin/prospects/Panel.js';
import 'SF/admin/prospects/RecordsPanel.js';
import 'SF/admin/prospects/data/MergeStore.js';
import 'SF/admin/prospects/data/Model.js';
import 'SF/ActionBar.js';
import 'SF/ActiveConcernChart.js';
import 'SF/AlertPanel.js';
import 'SF/AttributePanel.js';
import 'SF/BluePanel.js';
import 'SF/BulkCourseWidget.js';
import 'SF/BulkSelectWidget.js';
import 'SF/Button.js';
import 'SF/ColumnPanel.js';
import 'SF/DashboardPanel.js';
import 'SF/DataView.js';
import 'SF/DatePicker.js';
import 'SF/ExternalContentWindow.js';
import 'SF/FeatureManager.js';
import 'SF/FileUploadWindow.js';
import 'SF/GridView.js';
import 'SF/InformationPanel.js';
import 'SF/ItemSelector.js';
import 'SF/Label.js';
import 'SF/ListPanelMixin.js';
import 'SF/LovGroupComboInfoViewPlugin.js';
import 'SF/MainNavigation.js';
import 'SF/NotificationCenter.js';
import 'SF/OrangePanel.js';
import 'SF/OverviewPanel.js';
import 'SF/PagingToolbar.js';
import 'SF/PermissionsPanel.js';
import 'SF/PermissionsPopup.js';
import 'SF/QRPanel.js';
import 'SF/QuickStudentSearchPanel.js';
import 'SF/RadioGroup.js';
import 'SF/RequirementDDPanel.js';
import 'SF/SelectionToolbar.js';
import 'SF/StatefulGroupTabPanel.js';
import 'SF/StatefulTabMixin.js';
import 'SF/StatefulTabPanel.js';
import 'SF/StoreMgr.js';
import 'SF/StudentListActionPanel.js';
import 'SF/StudentListAdvancedFilterAttributesPanel.js';
import 'SF/StudentListAdvancedFilterPanel.js';
import 'SF/StudentListFilterPanel.js';
import 'SF/StudentListFilterPopup.js';
import 'SF/StudentListFilterWindow.js';
import 'SF/StudentListNameTemplate.js';
import 'SF/StudentListPagingToolbar.js';
import 'SF/StudentListPanel.js';
import 'SF/Tenant.js';
import 'SF/TextExtendPopup.js';
import 'SF/UpcomingAppointmentsChart.js';
import 'SF/WaiComplianceWrapper.js';
import 'SF/bundle.js';
import 'SF/course/CourseGradeFormatter.js';
